var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DotEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "24px",
    height: "24px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-122.88,-122.88) scale(1.96,1.96)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,6c-3.30186,0 -6,2.69814 -6,6c0,3.30186 2.69814,6 6,6c3.30186,0 6,-2.69814 6,-6c0,-3.30186 -2.69814,-6 -6,-6zM12,8c2.22098,0 4,1.77902 4,4c0,2.22098 -1.77902,4 -4,4c-2.22098,0 -4,-1.77902 -4,-4c0,-2.22098 1.77902,-4 4,-4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DotEmpty);
export default __webpack_public_path__ + "static/media/icons8-dot-empty.d813a24d23dea40f683f071ac687d450.svg";
export { ForwardRef as ReactComponent };